import React, { useEffect, useState } from "react";
import Headerstatic from "./Headerstatic";
import Footer from "./Footer";
import axios from "axios";

function Termsandconditions() {

  const [data16, setdata16] = useState([]);

  const [data17, setdata17] = useState([]);

  const [data18, setdata18] = useState([]);

  useEffect(() => {
    datas();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const api_url = "https://icreatedegreecollege.com/api";

  const datas = () => {
    axios
      .post("https://icreatedegreecollege.com/api/api/web/landing/getitems", {}, {})
      .then(
        (res) => {
          if (res.status === 200) {
            setdata16(res.data.certificateResult);
            setdata17(res.data.ratingResult);
            setdata18(res.data.contactInfoResult[0]);
          }
        },
        (error) => {
          if (error.response && error.response.status === 400) {
            console.log(error.response.data.message);
          }
        }
      );
  };



  return (
    <div>
      <Headerstatic />
      <div className="container">
        <div class="cardpad mt-3 pt-3 mt-md-5 pt-md-5">
          <div className="text-center text-primary pt-5">
            <h3 style={{ color: "#12498b" }} >Terms & Conditions</h3>
          </div>
          <h5 className="mt-3 mt-md-5">PLEASE READ THE FOLLOWING CAREFULLY</h5>
          <p>
            By accessing this website and using this service, you agree to abide
            by the Terms and Conditions ( Referred to as T&C in the future)
            mentioned in this document.
          </p>
          <p>
            This Site/Service is owned and operated by icreate degree college.
          </p>
          <p>
            icreate degree college reserves the right to modify/update the T&C of
            the provided service without prior notice.
          </p>
          <p>
            Please refrain from using this service if you are in disagreement with
            any of the Terms mentioned.
          </p>
          <p>
            The users of https://icreatedegreecollege.com claim the entire responsibility for
            the selection and use of the service(s) and none of its information
            providers, licensers, employees or agents shall have any liability for
            any errors, malfunctions, defects, loss of data, resulting from the
            inability to use the service.
          </p>
        </div>
      </div>
      <Footer data16={data16} data17={data17} data18={data18} />
    </div>
  );
}

export default Termsandconditions;
